import { useCallback, useContext, useMemo, useRef } from "react";
import { StyleSheet, View } from "react-native";
import { loadLoadoutFromPosition } from "../../backend/autocast/Autocast";
import { PlayerContext } from "../../backend/PlayerContext";
import { Button } from "./Button";
import { Text } from "./Text";

export function AutocastLoadoutLoadContainer(props: {}) {
  const playerContext = useContext(PlayerContext);
  const playerContextRef = useRef(playerContext);
  playerContextRef.current = playerContext;

  const loadoutObjects = playerContext.global.autocastLoadouts ?? [];
  const loadPosition = useCallback((position: number) => {
    playerContextRef.current.apply((state) =>
      loadLoadoutFromPosition(state, position),
    );
  }, []);
  return useMemo(
    () => (
      <View style={styles.loadoutsLoadRow}>
        <View style={styles.loadTextContainer}>
          <Text>Load:</Text>
        </View>
        {loadoutObjects.length > 0 ? (
          loadoutObjects.map((loadoutObject, idx) => {
            if (loadoutObject == null) {
              return null;
            }
            const name =
              loadoutObject?.name != ""
                ? loadoutObject?.name
                : "Slot " + (idx + 1);
            return (
              <Button
                key={idx}
                title={name}
                containerStyle={styles.loadButton}
                titleStyle={styles.smallButtonTitle}
                onPress={loadPosition.bind(null, idx)}
              />
            );
          })
        ) : (
          <Text style={styles.noLoadoutsText}>
            No loadouts have been saved yet!
          </Text>
        )}
      </View>
    ),
    [JSON.stringify(loadoutObjects), loadPosition],
  );
}

const styles = StyleSheet.create({
  loadoutsLoadRow: {
    flexDirection: "row",
    flexWrap: "wrap",
    alignItems: "center",
  },
  loadButton: {
    marginLeft: 8,
  },
  loadTextContainer: {
    marginRight: 8,
  },
  noLoadoutsText: {
    fontStyle: "italic",
  },
  smallButtonTitle: {
    fontSize: 12,
  },
});
